export default __webpack_public_path__ + "static/media/chance.1c5c3ff9.png";